"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@material-ui/core/utils");
exports.default = utils_1.createSvgIcon(React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M20.909 12a8.91 8.91 0 11-17.818 0 8.91 8.91 0 0117.818 0zm2 0c0 6.025-4.884 10.91-10.91 10.91-6.024 0-10.908-4.885-10.908-10.91S5.975 1.09 12 1.09 22.909 5.976 22.909 12zM9.228 8.727a.5.5 0 00-.5.5v1.618a.5.5 0 00.5.5h1.618a.5.5 0 00.5-.5V9.227a.5.5 0 00-.5-.5H9.228zm-.5 4.428a.5.5 0 01.5-.5h1.618a.5.5 0 01.5.5v1.618a.5.5 0 01-.5.5H9.228a.5.5 0 01-.5-.5v-1.618zm3.927 0a.5.5 0 01.5-.5h1.618a.5.5 0 01.5.5v1.618a.5.5 0 01-.5.5h-1.618a.5.5 0 01-.5-.5v-1.618zm0-3.928a.5.5 0 01.5-.5h1.618a.5.5 0 01.5.5v1.618a.5.5 0 01-.5.5h-1.618a.5.5 0 01-.5-.5V9.227z" }), "InLibrary");
//# sourceMappingURL=InLibrary.js.map